<template>
  <w-settings-content-template>
    <div slot="content">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-row class="title-bar" type="flex" justify="space-between">
              <div class="vertical-center-box">
                <div class="title-h3 mr-r15">알람 목록</div>
                <div class="setting-addel">
                  <el-button size="mini" @click="addLogAlarm"><i class="fas fa-plus"></i></el-button>
                  <el-button size="mini" @click="deleteLogAlarm" :disabled="!alramSelectFlag"><i class="fas fa-minus"></i></el-button>
                </div>
              </div>
              <div class="vertical-center-box" align="right">
                <el-button type="primary" size="mini" class="mr-r4" @click="updateAlarmList" :disabled="checkUpdateFlag">저장</el-button>
                <el-button size="mini" class="mr-r4" @click="resetAlarmList" :disabled="checkUpdateFlag">취소</el-button>
                <w-header-search-button @click="showSearchHeader"/>
              </div>
            </el-row>
            <!--알람 테이블-->
            <el-row>
              <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" :data="logalarmData" :columns="logalarmColumns" :pagination="true"  @condition-change="setTableParameter" remote
                :show-custom-header="true" :show-search-tool="searchFlag" ref="logAlarmTable" header-align="center" highlight-current-row @selection-change="changeSelection"  @cell-click="selectAlarm" @cell-dblclick="showDetailAlarmPopup">
                <template slot-scope="scope" slot="apply-flag-slot">
                  <el-switch v-model="scope.row.applyFlag" active-value="Y" inactive-value="N" @change="checkUpdate"/>
                </template>
              </el-table-wrapper>
            </el-row>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-row class="title-bar" type="flex" justify="space-between">
              <div class="vertical-center-box">
                <div class="title-h3 mr-r15">이벤트 등급</div>
              </div>
              <div class="vertical-center-box" align="right">
                <w-header-search-button @click="showSearchEventHeader"/>
              </div>
            </el-row>
            <!--이벤트 테이블-->
            <el-row>
              <el-table-wrapper :column-default="columnDefault" :data="alarmEventData" :columns="eventColumns" :pagination="false"
                :show-custom-header="true" :show-search-tool="searchEventFlag" ref="logalarmTable" header-align="center" highlight-current-row>
                <template slot-scope="scope" slot="eventlevelId-slot">
                  <w-eventlevel-cell :eventlevel-id="scope.row.eventlevelId"/>
                </template>
              </el-table-wrapper>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
      <w-log-alarm-settings-popup @loadAlarmList="loadData" :isAdd="isAdd" :selectAlarmData="detailAlarmData" ref="logalarmAddPopup"></w-log-alarm-settings-popup>
    </div>
</w-settings-content-template>
</template>
<script>
import AlarmAPI from '@/api/settings/log/lms-alarm-setting';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import { columnDefault } from '@/constants/table';
import { isEmpty, differenceWith, isEqual, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WLogAlarmSettingsPopup from './popup/LogAlarmSettingsPopup';

export default {
  name: 'WLogalarmSettings',
  components: {
    WSettingsContentTemplate,
    WEventlevelCell,
    WLogAlarmSettingsPopup,
  },
  data() {
    const eventCountColumns = [
      {
        prop: 'eventlevelName',
        label: '등급',
        width: 70,
        scopedSlot: 'eventlevelId-slot',
        headerAlign: 'center',
        columnKey: 'eventlevelId',
      },
      {
        label: '발생 조건',
        searchable: true,
        prop: 'eventConditionLabel',
      },
    ];
    return {
      limit: 50,
      start: 0,
      searchParams: [],
      checkUpdateFlag: true,
      searchFlag: false,
      isAdd: true,
      searchEventFlag: false,
      updateList: [],
      originAlarmEventData: [],
      alramSelectFlag: false,
      selectAlarmData: {},
      detailAlarmData: {},
      receiverData: [],
      selectEventData: [],
      eventCountColumns,
      logalarmData: [],
      alarmEventData: [],
      columnDefault,
      delteAlarmList: [],
      eventColumns: eventCountColumns,
      logalarmColumns: [
        {
          type: 'selection',
          width: '50',
          prop: 'check_flag',
        },
        {
          label: '활성화',
          width: 70,
          prop: 'applyFlag',
          scopedSlot: 'apply-flag-slot',
          headerAlign: 'center',
          align: 'center',
        },
        {
          label: '알람명',
          searchable: true,
          sortable: true,
          prop: 'eventName',
          remoteProp: 'event_name',
        },
        {
          label: '알람 종류',
          prop: 'eventTypeAlarmName',
          remoteProp: 'event_type_alarm_name',
          searchable: true,
          width: 130,
          sortable: true,
        },
        {
          label: '알람 조건',
          prop: 'eventTypeName',
          remoteProp: 'event_type_name',
          searchable: true,
          width: 150,
        },
        {
          label: '알람 조건값',
          prop: 'eventValueLabel',
          remoteProp: 'event_value_label',
          width: 200,
          searchable: true,
          scopedSlot: 'event-value-slot',
        },
      ],

    };
  },
  mounted() {
    this.limit = 50;
    this.start = 0;
    this.searchParams = [];
    this.loadData();
  },
  methods: {
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadData();
    },
    showSearchEventHeader() {
      this.searchEventFlag = !this.searchEventFlag;
    },
    showSearchHeader() {
      this.searchFlag = !this.searchFlag;
    },
    resetAlarmList() {
      this.logalarmData = cloneDeep(this.originAlarmEventData);
    },
    /**
     * 알람 활성화 스위치 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    checkUpdate() {
      const updateList = differenceWith(this.logalarmData, this.originAlarmEventData, isEqual);
      this.updateList = updateList;
      this.checkUpdateFlag = isEmpty(updateList);
    },
    /**
     * 알람 목록 체크 박스 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    changeSelection(data) {
      if (data.length > 0) {
        this.alramSelectFlag = true;
      } else {
        this.alramSelectFlag = false;
      }
      this.delteAlarmList = data;
    },
    /**
     * 이벤트 목록 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadEventData() {
      const param = {
        eventId: this.selectAlarmData.eventId,
      };
      AlarmAPI.getEventList(param).then((response) => {
        if (response.data.success) {
          this.alarmEventData = response.data.data;
          this.selectEventData = cloneDeep(response.data.data);
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '이벤트 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 알람 목록 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadData() {
      const param = {
        start: this.start,
        limit: this.limit,
        searchParams: this.searchParams,
      };
      AlarmAPI.getLmsAlarmList(param).then((response) => {
        if (response.data.success) {
          this.logalarmData = response.data.data;
          this.originAlarmEventData = cloneDeep(response.data.data);

          if (isEmpty(response.data.data)) {
            this.alarmEventData = [];
          }

          if (!isEmpty(response.data.data)) {
            this.$nextTick(() => {
              this.selectAlarmData = this.logalarmData[0];
              this.$refs.logAlarmTable.$children[0].setCurrentRow(this.logalarmData[0]);
              this.checkUpdateFlag = true;
              this.loadEventData();
            });
          }
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '알람 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 저장 버튼 클릭 시 수정한 알람 적용
     * @author leesy918
     * @return {[type]} [description]
     */
    updateAlarmList() {
      const params = this.updateList;
      AlarmAPI.updateAlarmList(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람', true));
          this.loadData();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '알람', false));
        throw new Error(e);
      });
    },
    /**
     * 알람 수정 팝업 출력 함수
     * @author leesy918
     * @return {[type]}     [description]
     */
    showDetailAlarmPopup() {
      this.isAdd = false;
      this.detailAlarmData = cloneDeep(this.selectAlarmData);
      this.detailAlarmData.eventSet = this.selectEventData;
      this.$refs.logalarmAddPopup.open();
    },
    /**
     * 로그 알람 추가 팝업 출력 함수
     * @author leesy918
     */
    addLogAlarm() {
      this.isAdd = true;
      this.$refs.logalarmAddPopup.open();
    },
    /**
     * 알람 삭제
     * @author leesy918
     * @return {[type]} [description]
     */
    deleteLogAlarm() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        const parmas = this.delteAlarmList;
        AlarmAPI.deleteLmsAlarm(parmas).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '알람', true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '알람', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '알람', false));
          throw new Error(e);
        });
      });
    },
    /**
     * 알람 선택에 따른 우측 이벤트 테이블 컬럼 변경 함수
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    selectAlarm(data) {
      this.selectAlarmData = cloneDeep(data);
      this.loadEventData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/LogAlarmSetting.vue